import { defineComponent as _defineComponent } from 'vue'
import { userApi } from '@/enitites/user'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useImage } from '@/shared/composables/image'
import { HeaderUserMenuLogoutButton } from '@/features/authorization'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAlert',
  setup(__props) {

const { getAvatar } = useImage()

const getUserDB = computed(() => store.getters.getUserDB)
const account = ref(getUserDB.value.id)
const isShowSwitchPanel = ref(false)
const router = useRouter()

watch(getUserDB, (value) => {
  account.value = value.id
})

async function fetchSelectedProfile(id: string) {
  isShowSwitchPanel.value = false
  localStorage.setItem('currentProfileId', id)
  const userDB = await userApi.getCurrentUser()
  await store.dispatch('setUserDB', userDB)
  router.go(0)
}

function openSwitchPanel() {
  isShowSwitchPanel.value = !isShowSwitchPanel.value
}

return { __sfc: true,getAvatar, getUserDB, account, isShowSwitchPanel, router, fetchSelectedProfile, openSwitchPanel, HeaderUserMenuLogoutButton }
}

})